<template>
    <span class="spinner visible anim-spin"></span>
</template>

<style scoped>
.spinner {
    position: absolute;
    top: 8px;
    right: 10px;
    background-color: #fff;
}
</style>
